import Breadcrumbs from "@app/shared/breadcrumbs/Breadcrumbs";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageHeaderRight from "@app/shared/PageHeaderRight";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { QESButton } from "@app/shared/qes-standards/Button";
import { NetworkSubmissionOverview } from "@app/compliance-connect/network-submission/NetworkSubmissionOverview";

enum NetworkSubmissionTabViews { ActiveNetworks, Archive };

export const NetworkSubmissionHome: FC = () => {
  const title = "Network Submissions";
  const [activeTab, setActiveTab] = useState<NetworkSubmissionTabViews>(NetworkSubmissionTabViews.ActiveNetworks);

  return (
    <Page documentTitle={title}>
      <Breadcrumbs items={[title]} />
      <PageInner>
        <PageHeader title={title} disableHR={true}>
          <PageHeaderRight>
            <Link to="./create" 
              className="qes-button qes-button-primary mt-1" 
              type="button">
              Create Network Submission
            </Link>
          </PageHeaderRight>
        </PageHeader>
        <PageSection>
          <div className="tabs-style-2 mb-3">
            <ul className="nav nav-tabs" role="tablist">
              <li>
                <QESButton
                  qesType="none"
                  className={`nav-link text-dark fw-normal ${activeTab === NetworkSubmissionTabViews.ActiveNetworks ? "active disabled" : ""}`}
                  qesTestId="network-submission-nav__tab--active-networks"
                  onClick={() => setActiveTab(NetworkSubmissionTabViews.ActiveNetworks)}
                  aria-disabled={activeTab === NetworkSubmissionTabViews.ActiveNetworks}
                  role="tab"
                >
                  Active Networks
                </QESButton>
              </li>
              <li>
                <QESButton
                  qesType="none"
                  className={`nav-link text-dark fw-normal ${activeTab === NetworkSubmissionTabViews.Archive ? "active disabled" : ""}`}
                  qesTestId="network-submission-nav__tab--archive"
                  onClick={() => setActiveTab(NetworkSubmissionTabViews.Archive)}
                  aria-disabled={activeTab === NetworkSubmissionTabViews.Archive}
                  role="tab"
                >
                  Archive
                </QESButton>
              </li>
            </ul>
          </div>
        </PageSection>

        <NetworkSubmissionOverview isArchivedTable={activeTab === NetworkSubmissionTabViews.Archive} />
      </PageInner>
    </Page>
  );
};
